import WdLoading from '@main/core/WdLoading';
import { Navigate } from 'react-router-dom';
import { generateRoutesFromAsyncList } from 'src/app/routing/utils/resolvers';
import {
  AdminConfig,
  ProfileConfig,
  BillingConfig,
  CompaniesConfig,
  DashboardConfig,
  Error404Page,
  ErrorPage,
  KiosksConfig,
  LocationsConfig,
  SetupConfig,
  SignInConfig,
  SignOutConfig,
  SignUpConfig,
  StripeConfig,
  TurnstilesConfig,
  UserRegistersConfig,
  SignValidateConfig,
  SignRecoveryConfig,
  RecognitionConfig,
} from '../views';

const disableDecorations = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
};

// ---- Rutas estáticas base que no requieren autenticación
export const staticRoutes = [
  {
    path: 'loading',
    element: <WdLoading />,
  },
  {
    path: '404',
    element: <Error404Page />,
    ...disableDecorations,
  },
  {
    path: 'error',
    element: <ErrorPage />,
    ...disableDecorations,
  },
  {
    path: '*',
    element: <Navigate to="/404" />,
  },
];

// ---- Aqui se agregan las rutas que se vayan requiriendo en la app --------
const mergedRoutes = [
  ProfileConfig,
  AdminConfig,
  DashboardConfig,
  SignOutConfig,
  SignInConfig,
  SignRecoveryConfig,
  SignUpConfig,
  CompaniesConfig,
  StripeConfig,
  BillingConfig,
  LocationsConfig,
  KiosksConfig,
  TurnstilesConfig,
  UserRegistersConfig,
  SetupConfig,
  SignValidateConfig,
  RecognitionConfig,
];

// ------ Exporta rutas al contexto global de la App -------------
export const asyncRoutes = [...generateRoutesFromAsyncList(mergedRoutes), ...mergedRoutes];

// ----- Lista blanca de rutas dinamicas que no requieren de autenticacion para acceder ------------
export const whiteList = ['sign-in', 'sign-up', 'sign-recovery', 'sign-validate'];
